module.exports = __webpack_public_path__ + "img/america.f95d188f.png";